//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BaseLoading from '@/components/BaseLoading';
import MonitoringAccessService from '@/apps/data-platform/services/reports/monitoring_access';
import AccessService from '@/apps/data-platform/services/tables_views/my_access_service';
import utils from '@/js/utils';
import { modalMixin } from '@/mixins/modal_mixin';
import ModalConfirm from '@/components/ModalConfirm';
export default {
  name: 'ModalAccess',
  mixins: [modalMixin],
  props: {
    tableReference: {
      type: Object,
      required: true,
      default: function _default() {}
    },
    source: {
      type: String,
      required: false,
      default: "bigquery"
    }
  },
  components: {
    BaseLoading: BaseLoading,
    ModalConfirm: ModalConfirm
  },
  data: function data() {
    return {
      MODAL_CONFIRM_REMOVE_ACCESS: 'MODAL_CONFIRM_REMOVE_ACCESS',
      isLoading: false,
      isBusy: false,
      pagination: {
        current: 1,
        limit: 5,
        total: 0,
        offset: 0
      },
      fields: [{
        value: 'applicant',
        text: 'Applicant'
      }, {
        value: 'owner',
        text: 'Benefited'
      }, {
        value: 'permissionExpirationDate',
        text: 'Expiration Date'
      }, {
        value: 'actions',
        text: '  ',
        class: 'text-center'
      }],
      items: []
    };
  },
  created: function created() {
    this.getTableAccess();
  },
  methods: {
    getTableAccess: function getTableAccess() {
      var _this = this;
      this.isLoading = true;
      this.params = {
        tableReference: this.tableReference,
        pagination: utils.cloneJSON(this.pagination)
      };
      AccessService.getUserAccess(this.params).then(function (response) {
        _this.items = response.data;
        _this.isLoading = false;
      });
    },
    removeAccess: function removeAccess(item) {
      var _this2 = this;
      this.isBusy = true;
      var table = item.table;
      var view = item.view;
      var params = {
        benefited: item.owner,
        domain: item.domain,
        tblProjectId: table.projectId,
        tblDatasetId: table.datasetId,
        tblObjectId: table.objectId,
        viwProjectId: view.projectId,
        viwDatasetId: view.datasetId,
        viwObjectId: view.objectId,
        source: this.source
      };
      console.log(params);
      MonitoringAccessService.removeAccessTable(params).then(function (response) {
        console.log(response);
        _this2.isBusy = false;
        _this2.$bvModal.hide(_this2.MODAL_CONFIRM_REMOVE_ACCESS);
        _this2.getTableAccess();
      });
    }
  },
  computed: {
    rows: function rows() {
      return this.items.length;
    }
  }
};